module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "dedi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("To"), _c('br'), _vm._v("SAMUEL\nRIDDLE"), _c('br'), _vm._v("Owner of Man o’ War"), _c('br'), _vm._v("and"), _c('br'), _vm._v("MELVILLE CHURCH II"), _c('br'), _vm._v("President, The Virginia\nHorseman’s Association in whose Thoroughbreds flows the blood of the Godolphin\nArabian")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "imager"
  }, [_c('img', {
    attrs: {
      "alt": "diagram",
      "height": "115",
      "src": "images/f0005-01.jpg",
      "width": "400"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2882f66e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedi.vue
// module id = 60
// module chunks = 0